import React from "react";

type FormTextAreaProps = {
    label: string;
    name: string;
    value: string;
    // eslint-disable-next-line no-unused-vars
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    error?: string;
    required?: boolean;
};

export default function FormTextArea({ label, name, value, onChange, error, required }: FormTextAreaProps) {
    return (
        <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700" htmlFor={name}>
                {label}
            </label>
            <textarea
                id={name}
                name={name}
                rows={4}
                value={value}
                onChange={onChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                required={required}
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}
        </div>
    );
}
